import { MabayaProductWithModelId } from '@/productDiscovery/SponsoredProducts/interfaces/MabayaProduct';

export const sponsoredDataInitialState: SponsoredDataState = {
  sponsoredProductsDisabled: false,
  highlightedProducts: { data: [], fetched: false },
  sponsoredPlaylist: { data: [], fetched: false },
  topProducts: [],
};

export interface SponsoredDataState {
  sponsoredProductsDisabled?: boolean;
  highlightedProducts?: { data: MabayaProductWithModelId[]; fetched: boolean };
  sponsoredPlaylist?: { data: MabayaProductWithModelId[]; fetched: boolean };
  topProducts?: MabayaProductWithModelId[];
}
